type SvgIconDef = {
  name: string;
  tag: string;
};

const outline = (body: string): string => `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    ${body}
  </svg>
`;

const homeIcon = outline(`
  <path d="M3 10.5L12 3l9 7.5"/>
  <path d="M5 9.5V21h14V9.5"/>
`);

const dashboardIcon = outline(`
  <rect x="3" y="3" width="8" height="8" rx="1"/>
  <rect x="13" y="3" width="8" height="5" rx="1"/>
  <rect x="13" y="10" width="8" height="11" rx="1"/>
  <rect x="3" y="13" width="8" height="8" rx="1"/>
`);

const folderIcon = outline(`
  <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8.5A2.5 2.5 0 0 1 18.5 20h-13A2.5 2.5 0 0 1 3 17.5V7z"/>
`);

const bankIcon = outline(`
  <path d="M12 4 3 8h18z"/>
  <path d="M3 9h18"/>
  <path d="M6 9v11"/>
  <path d="M10 9v11"/>
  <path d="M14 9v11"/>
  <path d="M18 9v11"/>
  <path d="M4 20h16"/>
`);

const peopleIcon = outline(`
  <circle cx="9" cy="8" r="2.5"/>
  <circle cx="16" cy="9" r="2"/>
  <path d="M4 19c0-3 2.5-5 5-5s5 2 5 5"/>
  <path d="M13 19c.2-1.8 1.5-3.2 3.5-3.7 1.7-.4 3.5.8 3.5 3.7"/>
`);

const chartIcon = outline(`
  <path d="M4 20h16"/>
  <path d="M7 16v-5"/>
  <path d="M12 16V9"/>
  <path d="M17 16V6"/>
  <path d="m6 10 4-4 3 2 5-4"/>
`);

const layersIcon = outline(`
  <path d="M12 3 3 8l9 5 9-5-9-5z"/>
  <path d="M3 13l9 5 9-5"/>
`);

const slidersIcon = outline(`
  <path d="M4 6h8"/>
  <path d="M16 6h4"/>
  <circle cx="14" cy="6" r="2"/>
  <path d="M4 12h4"/>
  <path d="M12 12h8"/>
  <circle cx="10" cy="12" r="2"/>
  <path d="M4 18h10"/>
  <path d="M18 18h2"/>
  <circle cx="16" cy="18" r="2"/>
`);

const assignmentIcon = outline(`
  <path d="M7 3h8l4 4v14H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/>
  <path d="M15 3v4h4"/>
  <path d="M9 12h8"/>
  <path d="M9 16h8"/>
`);

const gavelIcon = outline(`
  <path d="m14 4 6 6"/>
  <rect x="9.5" y="2.5" width="4" height="8" rx="1" transform="rotate(-45 11.5 6.5)"/>
  <rect x="4.5" y="7.5" width="4" height="8" rx="1" transform="rotate(-45 6.5 11.5)"/>
  <path d="M2 22h9"/>
`);

const policeIcon = outline(`
  <path d="M12 3 5 6v5c0 4.2 2.8 8 7 10 4.2-2 7-5.8 7-10V6l-7-3z"/>
  <path d="m12 8 1.2 2.4 2.6.4-1.9 1.9.4 2.6-2.3-1.2-2.3 1.2.4-2.6-1.9-1.9 2.6-.4z"/>
`);

const inventoryIcon = outline(`
  <path d="M3 7.5 12 3l9 4.5-9 4.5z"/>
  <path d="M3 7.5V16.5L12 21l9-4.5V7.5"/>
  <path d="M12 12v9"/>
`);

const swapHorizontalIcon = outline(`
  <path d="M7 7h14"/>
  <path d="m17 3 4 4-4 4"/>
  <path d="M17 17H3"/>
  <path d="m7 13-4 4 4 4"/>
`);

const messageIcon = outline(`
  <path d="M5 5h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9l-5 4v-4H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"/>
`);

const listIcon = outline(`
  <path d="M9 6h11"/>
  <path d="M9 12h11"/>
  <path d="M9 18h11"/>
  <circle cx="5" cy="6" r="1"/>
  <circle cx="5" cy="12" r="1"/>
  <circle cx="5" cy="18" r="1"/>
`);

const saveIcon = outline(`
  <path d="M5 4h12l3 3v13H4V4h1z"/>
  <path d="M8 4v5h7V4"/>
  <rect x="8" y="14" width="8" height="6" rx="1"/>
`);

const eyeIcon = outline(`
  <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"/>
  <circle cx="12" cy="12" r="2.5"/>
`);

const globeIcon = outline(`
  <circle cx="12" cy="12" r="9"/>
  <path d="M3 12h18"/>
  <path d="M12 3c2.5 2.6 4 5.8 4 9s-1.5 6.4-4 9c-2.5-2.6-4-5.8-4-9s1.5-6.4 4-9z"/>
`);

const dnsIcon = outline(`
  <rect x="4" y="5" width="16" height="5" rx="1.5"/>
  <rect x="4" y="14" width="16" height="5" rx="1.5"/>
  <path d="M8 8h.01"/>
  <path d="M8 17h.01"/>
  <path d="M12 8h.01"/>
  <path d="M12 17h.01"/>
`);

const churchIcon = outline(`
  <path d="M12 3v4"/>
  <path d="M10 5h4"/>
  <path d="M6 10h12v11H6z"/>
  <path d="M4 10 12 6l8 4"/>
  <path d="M10 21v-5h4v5"/>
`);

const workIcon = outline(`
  <rect x="3" y="7" width="18" height="13" rx="2"/>
  <path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
  <path d="M3 12h18"/>
`);

const locationIcon = outline(`
  <path d="M12 21s7-5.9 7-11a7 7 0 1 0-14 0c0 5.1 7 11 7 11z"/>
  <circle cx="12" cy="10" r="2.5"/>
`);

const adminIcon = outline(`
  <path d="M12 3 5 6v6c0 4.2 2.8 8 7 10 4.2-2 7-5.8 7-10V6l-7-3z"/>
  <path d="M9.5 12.5 11 14l3.5-3.5"/>
`);

const badgeIcon = outline(`
  <rect x="3" y="5" width="18" height="14" rx="2"/>
  <circle cx="9" cy="11" r="2"/>
  <path d="M6.5 16c.7-1.3 2-2 3.5-2s2.8.7 3.5 2"/>
  <path d="M15 9h3"/>
  <path d="M15 12h3"/>
`);

export const NAV_MENU_SVG_ICONS: SvgIconDef[] = [
  { name: 'home', tag: homeIcon },
  { name: 'dashboard', tag: dashboardIcon },
  { name: 'folder', tag: folderIcon },
  { name: 'account_balance', tag: bankIcon },
  { name: 'business', tag: bankIcon },
  { name: 'people_alt', tag: peopleIcon },
  { name: 'group', tag: peopleIcon },
  { name: 'groups', tag: peopleIcon },
  { name: 'assessment', tag: chartIcon },
  { name: 'analytics', tag: chartIcon },
  { name: 'bar_chart', tag: chartIcon },
  { name: 'trending_up', tag: chartIcon },
  { name: 'stacked_bar_chart', tag: layersIcon },
  { name: 'tune', tag: slidersIcon },
  { name: 'settings', tag: slidersIcon },
  { name: 'assignment', tag: assignmentIcon },
  { name: 'gavel', tag: gavelIcon },
  { name: 'local_police', tag: policeIcon },
  { name: 'inventory', tag: inventoryIcon },
  { name: 'swap_horiz', tag: swapHorizontalIcon },
  { name: 'feedback', tag: messageIcon },
  { name: 'sms', tag: messageIcon },
  { name: 'list', tag: listIcon },
  { name: 'save', tag: saveIcon },
  { name: 'visibility', tag: eyeIcon },
  { name: 'public', tag: globeIcon },
  { name: 'dns', tag: dnsIcon },
  { name: 'church', tag: churchIcon },
  { name: 'work', tag: workIcon },
  { name: 'location_on', tag: locationIcon },
  { name: 'admin_panel_settings', tag: adminIcon },
  { name: 'badge', tag: badgeIcon },
];
